
<template>
<div>
    <a-modal
      :title="modalState.title"
      :visible="modalState.isShow"
     :confirm-loading="confirmLoading"
     width="600px"
      @cancel="handleCancel"
    >
     <a-input-group compact style="margin-bottom:10px;">
      <a-select default-value="zname" @change="onSearchChange">
        <a-select-option value="zname">
          模块编码
        </a-select-option>
        <a-select-option value="zcode">
          系统编码
        </a-select-option>
      </a-select>
      <a-input-search style="width: 50%" default-value="" :id="currentAppSelectSearchInput"  @search="onSearch" />
    </a-input-group>

     <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType,getCheckboxProps:getCheckboxProps}"
      :columns="columns"
      :data-source="list"
      rowKey="appcode"
      :pagination="false"
      :scroll="{ x: 560}"
    />

    <br />

    <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" style="float:right;" show-less-items />
    <br />

     <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>

const columns = [
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
    },
    {
        title: '模块编码',
        dataIndex: 'appcode',
        align: 'center',
    },
    {
        title: '模块英文简称',
        dataIndex: 'appenname',
        align: 'center',
    },
    {
        title: '模块中文简称',
        dataIndex: 'appname',
        align: 'center',
    }
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [],
            list:[],
            searchKey:'zname',
            searchVal:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            originData:[],
            savedPages:[],
            getCheckboxProps: record => ({
                props: {
                    disabled: record.appcode === this.modalState.filterAppcode, // Column configuration not to be checked
                }
            }),
            currentAppSelectSearchInput:'currentAppSelectSearchInput'
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
        modalState:{
            isShow:false,
            rowsType:'checkbox',
            selectkeys:undefined,
            filterAppcode:'',
            flag:0,
            authedAppData:[]
        }
    },
    methods: {
        handlePageChange(params_page){
            this.onModalInit(params_page)
        },
        onModalInit(pageNum){
            let that = this;
            that.originData = that.modalState.authedAppData ? that.modalState.authedAppData : [];
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum,
                flag:1,
                urlparams:false,
            }
            if(that.searchKey == 'zname' && that.searchVal){
                c_params.appcode = that.searchVal
            }
            else if(that.searchKey == 'zcode' && that.searchVal){
                c_params.syscode = that.searchVal
            }
            that.$store.dispatch({
                type: "servicekey/getAppList",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    if(that.modalState.selectkeys){
                        that.selectedRowKeys = that.modalState.selectkeys
                    }
                    let result = res.data.data;
                   
                    // if(that.savedPages.indexOf(pageNum) == -1){
                    //     that.savedPages.push(pageNum)
                    //     if(result.list){
                    //         that.originData = that.originData.concat(result.list)
                    //     }
                    // }
                    that.originData = that.originData.concat(result.list)

                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                else{
                    that.message.error('获取APP列表失败')
                }
            })
        },


        onSearchChange(value){
            this.searchKey = value;
        },
        onSearch(value){
            this.searchVal = value;
            this.onModalInit(); 
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
            // console.log(this.selectedRowKeys)
            // console.log(JSON.stringify(this.originData))
            // let current_keys = this.selectedRowKeys;
            // let result = this.originData.filter(function(n){
            //     return current_keys.indexOf(n.appcode) != -1
            // });
            // console.log(result)
        },
        handleOk(){
            let that = this;
            let current_keys = this.selectedRowKeys;
            let result = [];

            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = that.originData.filter(function(n){
                    return element == n.appcode
                });
                if(c_item.length == 0){
                    result = undefined
                    console.log("未找到对应数据")
                    break;
                }
                result.push(c_item[0])
            }
            this.$emit('onModalHide',result);
            this.selectedRowKeys = [];
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide',undefined);
        }
    },
    mounted() {
    },
    watch:{
        'modalState.isShow'(newVal){
            if(newVal){
                setTimeout(() => {
                    document.getElementById('currentAppSelectSearchInput').focus()
                }, 500);
                this.onModalInit(1);
            }
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
